<template>
  <v-switch
    v-bind="$attrs"
    v-on="$listeners"
    class="switcher"
    v-model="model"
    :key="reRenderKey"
  ></v-switch>
</template>

<script>
export default {
  model: "change",
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      reRenderKey: 0
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$off();
        this.$emit("change", val);
        this.reRenderKey++;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
